// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wa_a bhr_b"};